import { render, staticRenderFns } from "./cfooter.vue?vue&type=template&id=30eb59b8&scoped=true"
import script from "./cfooter.vue?vue&type=script&lang=js"
export * from "./cfooter.vue?vue&type=script&lang=js"
import style0 from "./cfooter.vue?vue&type=style&index=0&id=30eb59b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30eb59b8",
  null
  
)

export default component.exports